<template>
  <div class="tw-flex tw-w-full tw-flex-col tw-gap-[10px] tw-mt-[10px]">
    <div
      v-for="(option, index) in options"
      :key="index"
      class="tw-grid tw-grid-cols-[1fr_auto_70px] tw-gap-[10px] tw-justify-items-end"
    >
      <div class="tw-text-left tw-w-full">
        <span v-if="dataLang[option?.finreestr_funds__name]">
          {{ dataLang[option?.finreestr_funds__name] }}
        </span>
        <span v-else>
          {{ option?.finreestr_funds__name }}
        </span>
      </div>

      <div class="tw-flex tw-justify-end tw-gap-[5px]">
        <div
          v-if="option.finreestr_funds__code == 'fund_1'"
          class="tw-w-[18px] tw-h-[18px] tw-bg-warning tw-flex tw-rounded-[3px] tw-items-center tw-justify-center tw-cursor-pointer"
          @click="$modal.show('onAddBalance')"
        >
          <img :src="require(`@/assets/icons/add-2-dark.svg`)" width="7.6" />
        </div>
        <div
          v-if="option.finreestr_funds__code == 'fund_1'"
          class="tw-w-[18px] tw-h-[18px] tw-bg-[#8000FF] tw-flex tw-rounded-[3px] tw-items-center tw-justify-center tw-cursor-pointer"
          @click="$modal.show('withdrawalOfFundsModal')"
        >
          <img
            :src="require(`@/assets/icons/toTop.svg`)"
            width="8.5"
            height="9.75"
          />
        </div>
        <div
          v-if="option.finreestr_funds__code != 'fund_1'"
          class="tw-w-[18px] tw-h-[18px] tw-bg-[#114BD4] tw-flex tw-rounded-[3px] tw-items-center tw-justify-center tw-cursor-pointer"
          @click="
            $modal.show('toMoveCost', {
              datas: option,
              type: 'transit',
            })
          "
        >
          <img
            :src="require(`@/assets/icons/moving.svg`)"
            width="8.5"
            height="9.75"
          />
        </div>
      </div>

      {{ option?.finreestr_funds__amount?.split(".")?.join(",") }}
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  props: ["options"],
  computed: {
    ...mapState("translationModule", ["dataLang"]),
  },
};
</script>
